export enum ExternalUrlGroupsSectionType {
  Details = 'details',
  Translations = 'translations',
  accessPolicy = 'accesspolicy',
  ExternalUrls = 'externalurls'
}
